export default __webpack_public_path__ + "static/media/flesh.5e4dd722.png";